import { render, staticRenderFns } from "./pelletsheizung.vue?vue&type=template&id=440b8584&scoped=true"
import script from "./pelletsheizung.vue?vue&type=script&lang=ts"
export * from "./pelletsheizung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b8584",
  null
  
)

export default component.exports